import { render } from "./PayNowQRCodeGeneric.vue?vue&type=template&id=5b472a44"
import script from "./PayNowQRCodeGeneric.vue?vue&type=script&lang=js"
export * from "./PayNowQRCodeGeneric.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__